import React, { Component } from "react";
import { connect } from "react-redux";

import withStyles from "@material-ui/styles/withStyles";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import ExcelIcon from "mdi-material-ui/FileExcel";

import { PageHeader, Button, crudGetOne, PageFooter, BackButton, RestMethods, FETCH_START, FETCH_END } from "jazasoft";

import OrderDetails from "../OrderDetails";
import { dataProvider } from "../../App";
import handleError from "../../utils/handleError";

const styles = theme => ({
  root: {},
  container: {
    margin: "1.5em",
    padding: 0
  },
  marginVertical: {
    margin: "1.5em 0"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    margin: "1.5em"
  }
});

// const styles = {
//   root: {
//     // margin: "1.5em",
//     // padding: "3em"
//   },
//   container: {
//     margin: "1.5em",
//     padding: 0
//   },
//   dispalyCenter: {
//     display: "flex",
//     justifyContent: "center"
//   }
// };

class Monitoring extends Component {
  state = {
    busy: false
  };

  componentDidMount() {
    this.updateOrder();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.updateOrder();
    }
  }

  updateOrder = (id = this.props.id) => {
    if (id) {
      this.props.dispatch(crudGetOne("orders", id, this.props.basePath, this.props.requestConfig));
    }
  };

  onDownload = orderFlow => () => {
    const options = {
      url: `monitors/${orderFlow.id}`,
      responseType: "arraybuffer"
    };
    this.setState({ busy: true });
    this.props.dispatch({ type: FETCH_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 200) {
          const header = response.headers["content-disposition"];
          var filename = header ? header.match(/filename="(.+)"/)[1] : "MONOTORING.xlsx";

          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        }
        this.props.dispatch({ type: FETCH_END });
        this.setState({ busy: false });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.setState({ busy: false });
      });
  };

  render() {
    const { classes, order, id } = this.props;

    return (
      <div className={classes.root}>
        <PageHeader title={`Order Monitoring #${id}`} />

        {order && Object.keys(order).length > 0 && (
          <div className={classes.container}>
            {/*Order Details */}
            <OrderDetails record={order} basePath="orders" resource="orders" />

            {order && order.orderFlowList && order.orderFlowList.length > 0 && (
              <Paper className={classes.marginVertical} square>
                <List>
                  {order.orderFlowList.map((oc, idx) => (
                    <ListItem key={idx}>
                      <ListItemText>{`${oc.part}, Lot${oc.lot}, ${oc.colors}`}</ListItemText>
                      <ListItemSecondaryAction>
                        <Button edge="end" aria-label="Print" style={{ color: "green" }} onClick={this.onDownload(oc)}>
                          <ExcelIcon style={{ marginRight: 4 }} />
                          Download
                        </Button>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}

            <PageFooter>
              <BackButton style={{ marginRight: 8 }} variant="contained" />
            </PageFooter>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const resourceState = state.jazasoft.resources["orders"];
  const id = props.match.params.id;
  return {
    id,
    order: resourceState && resourceState.data && resourceState.data[id]
  };
};

export default connect(mapStateToProps)(withStyles(styles)(Monitoring));
